import { Button, PageHeader } from 'components';
import { Form, Row, Col } from 'antd';
import styles from './style.module.scss';
import { ImportOutlined } from '@ant-design/icons';
import InfoSection from './formSections/info';
import { useTranslation } from 'react-i18next';
import FileSection from './formSections/file';
import useCalendarCategories from '../useCalendarCategories';

const Import = () => {
  const { t } = useTranslation();

  const { shoppingCenters, form, handleImportExcel, updateInProcess } =
    useCalendarCategories(false);

  const onFinish = async (values) => {
    await handleImportExcel(values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  const onClickSave = () => {
    form.submit();
  };

  const title = t('TRADING CALENDAR IMPORTS');

  return (
    <div>
      <PageHeader title={title}>
        <Row gutter={16}>
          <Col>
            <Button
              onClick={onClickSave}
              width={'150px'}
              big
              icon={<ImportOutlined />}
              loading={updateInProcess}
            >
              {t('IMPORT')}
            </Button>
          </Col>
        </Row>
      </PageHeader>
      <div className={styles.content}>
        <Form
          form={form}
          name='basic'
          wrapperCol={{
            span: 24,
          }}
          initialValues={{
            shopping_center_id: '',
          }}
          layout={'vertical'}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete='off'
        >
          <InfoSection shoppingCenters={shoppingCenters} />
          <FileSection />
        </Form>
      </div>
    </div>
  );
};

export default Import;
